import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BookingList } from "../../interface/booking-list.interface";
import axios from "axios";
import axiosInstance from "@/lib/axios";

// Fetch bookings thunk
export const fetchBookings = createAsyncThunk<BookingList>(
  "bookings/fetchBookings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/bookings");
      return response.data as BookingList;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

interface BookingState {
  bookings: BookingList;
  loading: boolean;
  error: string | null;
}

const initialState: BookingState = {
  bookings: [],
  loading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload;
      })
      .addCase(fetchBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default bookingSlice.reducer;
